module.exports = __webpack_public_path__ + "static/media/hypo-logo-complete-blue.c7c2a3c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hypo-logo-complete-blue.svg
// module id = 567
// module chunks = 0